<template>
  <section class="match-reward-individual-section">
    <img class="individual-character" :src="individualPrizeData.characterImage" alt="" />

    <div class="individual-title">
      <img :src="individualPrizeData.titleImage" alt="个人奖项" />
    </div>

    <div class="individual-board">
      <img class="individual-prize-image" :src="individualPrizeData.prizeImage" alt="个人奖项奖励" />
      <img class="individual-left-decoration" :src="individualPrizeData.leftDecorationImage" alt="" />

      <div class="individual-evaluation">{{ individualPrizeData.evaluationText }}</div>

      <img class="award-label command-label" :src="individualPrizeData.commandAwardLabelImage" alt="优秀指挥奖" />
      <div class="award-table command-award-table">
        <div v-for="item in individualPrizeData.commandAwards" :key="item.rank" class="award-table-row">
          <div class="award-reward">{{ item.reward }}</div>
          <div class="award-rank">{{ item.rank }}</div>
        </div>
      </div>

      <img class="award-label kill-label" :src="individualPrizeData.killAwardLabelImage" alt="击杀奖" />
      <div class="award-table kill-award-table">
        <div class="kill-award-text">{{ individualPrizeData.killAward }}</div>
        <div class="kill-rule-text">{{ individualPrizeData.killRule }}</div>
        <div class="kill-awards-text">{{ individualPrizeData.killAwards }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchRewardIndividualPrizeSection',
  props: {
    individualPrizeData: { type: Object, required: true },
  },
}
</script>

<style scoped lang="scss">
.match-reward-individual-section {
  position: relative;
  height: 8.322917rem;

  .individual-character {
    position: absolute;
    top: -1.088542rem;
    left: 0;
    z-index: 0;
    width: 5.958333rem;
    height: 3.921875rem;
    opacity: 0.8;
    pointer-events: none;
  }

  .individual-title,
  .individual-board {
    position: relative;
    z-index: 1;
  }

  .individual-title {
    width: 6.880208rem;
    height: 0.875rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.875rem;
    }
  }

  .individual-board {
    width: 7.291667rem;
    height: 6.729167rem;
    margin: 0.71875rem auto 0;

    .individual-prize-image {
      display: block;
      width: 7.291667rem;
      height: 6.729167rem;
    }

    .individual-left-decoration,
    .individual-evaluation,
    .award-label,
    .award-table {
      position: absolute;
    }

    .individual-left-decoration {
      top: 2.692708rem;
      right: -0.567708rem;
      z-index: 1;
      width: 2.807292rem;
      height: 3.541667rem;
      pointer-events: none;
    }

    .individual-evaluation {
      top: -0.125rem;
      left: 0;
      width: 7.291667rem;
      height: 0.25rem;
      color: #773700;
      font-size: 0.145833rem;
      font-weight: 700;
      line-height: 0.25rem;
      text-align: center;
    }

    .award-label {
      left: 50%;
      width: 2.807292rem;
      height: 0.651042rem;
      transform: translateX(-50%);
    }

    .command-label {
      top: 0.911458rem;
    }

    .kill-label {
      top: 3.1875rem;
    }

    .award-table {
      left: 50%;
      width: 5.208333rem;
      min-height: 1.09375rem;
      transform: translateX(-50%);
      background: rgba(22, 33, 38, 0.7);
      color: #ffffff;
      box-sizing: border-box;
      z-index: 6;
    }

    .command-award-table {
      top: 1.84375rem;
      padding: 0 0.520833rem;

      .award-table-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        height: 0.364583rem;
        border-bottom: 0.005208rem solid rgba(255, 255, 255, 0.18);
        font-size: 0.104167rem;
        line-height: 0.364583rem;

        &:last-child {
          border-bottom: 0;
        }

        .award-reward,
        .award-rank {
          height: 0.364583rem;
          line-height: 0.364583rem;
          text-align: center;
        }

        .award-rank {
          border-left: 0.005208rem solid rgba(255, 255, 255, 0.18);
        }
      }
    }

    .kill-award-table {
      top: 4.015625rem;
      padding: .104167rem
        /* 20/192 */
      ;
      padding-top: 0.15625rem;
      text-align: center;

      .kill-award-text {
        height: 0.25rem;
        font-size: 0.104167rem;
        line-height: 0.25rem;
      }

      .kill-rule-text {
        margin-top: 0.026042rem;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.09375rem;
        line-height: 0.25rem;
        text-align: left;
      }

      .kill-awards-text {
        margin-top: 0.026042rem;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.09375rem;
        line-height: 0.25rem;
        text-align: left;
      }
    }
  }
}

@media (max-width: 750px) {
  .match-reward-individual-section {
    height: auto;
    padding-bottom: 24vw;

    .individual-character {
      top: -8vw;
      width: 118vw;
      height: auto;
    }

    .individual-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .individual-board {
      width: 96%;
      height: 8.853rem;
      margin-top: 12vw;

      .individual-prize-image {
        width: 100%;
        height: auto;
        display: none;
      }

      .individual-left-decoration {
        top: 40%;
        right: -7vw;
        z-index: 0;
        width: 36vw;
        height: auto;
      }

      .individual-evaluation {
        top: -7vw;
        width: 100%;
        height: auto;
        font-size: 3vw;
        line-height: 4.5vw;
        box-sizing: border-box;
      }

      .command-label {
        top: 9%;
        width: 40%;
        height: auto;
      }

      .kill-label {
        top: 52.4%;
        width: 40%;
        height: auto;
      }

      .award-table {
        width: 81%;
        height: 28%;
        min-height: 0;
      }

      .command-award-table {
        top: 21.4%;
        padding: 0vw;

        .award-table-row {
          height: 33.333%;
          font-size: 3vw;
          line-height: normal;

          .award-reward,
          .award-rank {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            line-height: normal;
          }
        }
      }

      .kill-award-table {
        top: 64.7%;
        padding: 2vw;
        height: auto;
        min-height: 22%;

        .kill-award-text {
          height: auto;
          font-size: 0.33rem;
          line-height: 4.5vw;
          padding: 0.5vw 0vw;
        }

        .kill-rule-text {
          height: auto;
          margin-top: 0;
          padding: 0 2vw;
          font-size: 0.32rem;
          line-height: 0.48rem;
          box-sizing: border-box;
        }

        .kill-awards-text {
          margin-top: 0.8vw;
          padding: 0 2vw;
          font-size: 0.32rem;
          line-height: 0.48rem;
          box-sizing: border-box;
        }
      }

    }
  }
}
</style>
